import { Component } from "@angular/core";

@Component({
	selector: 'dms-button-bar',
	template: `<div class="well well-sm buttonBar" name="buttonBar"><ng-content></ng-content></div>`
})
export class ButtonBarComponent {

}